import { c as _c } from "react/compiler-runtime";
import type { Theme } from '@onefootprint/design-tokens';
import type { FootprintAppearance } from '@onefootprint/footprint-js';
import { DesignSystemProvider } from '@onefootprint/ui';
import type React from 'react';
import type { AppearanceOptions } from '../../appearence.types';
import AppearanceContext from './appearance-context';
import ApplyDarkClass from './components/apply-dark-class';
import LoadAppearanceInBrowser from './components/load-appearance-in-browser';
import LoadCssVariables from './components/load-css-variables';
import LoadRules from './components/load-rules';
type AppearanceProviderProps = {
  appearance?: never;
  children: React.ReactNode;
  options?: AppearanceOptions;
  rules?: never;
  theme?: never;
} | {
  appearance: FootprintAppearance;
  children: React.ReactNode;
  options?: never;
  rules: string;
  theme: Theme;
};
const AppearanceProvider = t0 => {
  const $ = _c(17);
  const {
    appearance,
    children,
    options,
    rules,
    theme
  } = t0;
  if (theme) {
    let t1;
    if ($[0] !== rules) {
      t1 = <LoadRules rules={rules} />;
      $[0] = rules;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== theme) {
      t2 = <LoadCssVariables theme={theme} />;
      $[2] = theme;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== appearance) {
      t3 = <ApplyDarkClass appearance={appearance} />;
      $[4] = appearance;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== appearance || $[7] !== children) {
      t4 = <AppearanceContext.Provider value={appearance}>{children}</AppearanceContext.Provider>;
      $[6] = appearance;
      $[7] = children;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
      t5 = <DesignSystemProvider>{t1}{t2}{t3}{t4}</DesignSystemProvider>;
      $[9] = t1;
      $[10] = t2;
      $[11] = t3;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  if (options) {
    let t1;
    if ($[14] !== children || $[15] !== options) {
      t1 = <LoadAppearanceInBrowser options={options}>{children}</LoadAppearanceInBrowser>;
      $[14] = children;
      $[15] = options;
      $[16] = t1;
    } else {
      t1 = $[16];
    }
    return t1;
  }
  return null;
};
export default AppearanceProvider;